export const createTree = (collection, left = 0, right = null) => {

    collection.sort((a, b) => a._lft - b._lft)

    let tree = []
    collection.forEach((item, i) => {
        if (item._lft === left + 1 && (right === null || item._rgt < right)) {
            if (tree[i] === undefined) tree[i] = {}
            tree[i] = item

            if (item._rgt - item._lft > 1) {
                const children = createTree(collection, item._lft, item._rgt)
                tree[i].children = children
            }

            left = item._rgt
        }
    })

    return tree.filter(el => el !== null)
}

export const hasChildren = element => {
    return element._rgt - element._lft > 1
}
export const isParent = hasChildren

export const getChildren = (collection, element) => {
    return collection.filter(el => el._lft > element._lft && el._rgt < element._rgt)
}

export const getAncestors = (collection, element) => {
    return collection.filter(el => el._lft < element._lft && el._rgt > element._rgt)
}

const NestedSet = {
    createTree,

    isParent,
    hasChildren,
    getChildren,
    getAncestors,
}

export default NestedSet
